import React, { useEffect } from 'react';
import { bindActionCreators } from 'redux';
import { connect } from 'react-redux';

import { withErrorBoundaryTrigger } from 'sharedComponents/ErrorBoundary';
import { getModel, getRawDataCollections } from './selectors';
import { ReportGeneratorComponent } from './ReportGeneratorComponent';

import * as actions from './actions';

import './style.scss';

const ReportGeneratorContainer = (props) => {
    useEffect(() => {
        return () => {
            props?.actions?.clearReportGeneration?.();
            props?.actions?.clearRawDataCollections?.();
        };
    }, []);

    return <ReportGeneratorComponent {...props} />;
};

const mapStateToProps = (state) => {
    const model = getModel(state);
    // rawDataCollections is passed as a sibling prop (not inside model) so that
    // withErrorBoundaryTrigger does not recursively scan it for error states.
    const rawDataCollections = getRawDataCollections(state);
    return {
        model,
        rawDataCollections
    };
};

const mapDispatchToProps = (dispatch) => {
    return {
        actions: bindActionCreators(actions, dispatch)
    };
};

const ReportGeneratorContainerWithErrorBoundaryTrigger = withErrorBoundaryTrigger(ReportGeneratorContainer);
const reportGeneratorContainerConn = connect(
    mapStateToProps,
    mapDispatchToProps
)(ReportGeneratorContainerWithErrorBoundaryTrigger);
export default reportGeneratorContainerConn;
